module.exports = __webpack_public_path__ + "static/media/reportCxcPdf.22b9e24f.svg";